import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=6e6cc3b9&"
import script from "./VerificationPage.vue?vue&type=script&lang=js&"
export * from "./VerificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports